module.exports = __webpack_public_path__ + "img/no-user-full.1548be3c.png";